import { callApi } from "./api";
import { getQueryString, getOffsetLimitFromPagination } from "../utils/query";

class MedicalReportsService {
  async getMedicalReportsPaged({
    currentPage,
    pageSize,
    searchValue,
    selectorValue,
    cancelToken,
    orderValue,
    finished
  }) {
    if (orderValue !== "") {
      searchValue = "";
      currentPage = 1;
    }
    const query = getQueryString({
      ...getOffsetLimitFromPagination({ currentPage, pageSize, selectorValue }),
      search: searchValue,
      status: selectorValue,
      ordering: orderValue ? orderValue : "-date_edited",
      finished:finished
    });

    return await callApi({
      url: `/api/medical_reports/${query}`,
      cancelToken,
    });
  }
   getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
}
 DataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}

   async dataForPost (data) {
   
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      
      if(value!=undefined){
        if(key=='images'){
          for (let i = 0; i < value.length; i++) {
            formData.append("images", value[i].originFileObj, value[i].name);
          }
              }
        else{
          formData.append(key,value)
        }
      
    }
    });

    return formData;
  }
   async finishReport(id) {
     return await callApi({url:`api/medical_report/finish/${id}/`})
   }
   async addReport(data) {
    try{
      data.images = await Promise.all( data.images.map(async (file)=>{
        return await this.getBase64(file.originFileObj);
       
      }))
      
    return await callApi({
      url: `/api/medical_reports/`,
      method: "POST",
      data:data,
    });
  }catch(e){
    console.log(e);
  }
  }

  async editMedicalReports(id, data) {
    try{

    data.images = await Promise.all( data.images.map(async (file)=>{
      if(file.originFileObj)
      return await this.getBase64(file.originFileObj);
       else {
       return file.url.split("/").pop();

     }
    }))
    return await callApi({
      url: `/api/medical_reports/${id}/`,
      method: "PATCH",
      data,
    });
    }catch(e){
      console.log(e);
    }
  }

  async getMedicalReportInfo(id) {
    return await callApi({ url: `/api/medical_reports/${id}/` });
  }

  /*async getMedicalReportPdf(id) {
    return await callApi({
      url: `/api/medical_reports_pdf/1/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });
  }*/
  async getMedicalReportPdf(id) {
    return await callApi({
      url: `/api/medical_reports_pdf/${id}`,
    });
  }

  async deleteMedicalReport(id) {
    return await callApi({
      url: `/api/medical_reports/${id}/`,
      method: "DELETE",
    });
  }
}

export const medicalReportsService = new MedicalReportsService();
